import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bd6033d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full bg-dynamicFooter pb-3 pt-6 text-xs text-white xs:text-sm sm:pt-12 sm:text-base lg:text-lg xl:text-xl" }
const _hoisted_2 = { class: "container mx-auto max-w-7xl px-3 sm:px-4" }
const _hoisted_3 = { class: "grid w-full grid-cols-2 gap-3 xs:gap-4 sm:grid-cols-3" }
const _hoisted_4 = { class: "hidden flex-col px-3 xs:px-4 sm:flex" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "mb-2 mt-6 lg:mb-3 lg:mt-7 xl:mb-4 xl:mt-9" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title my-2 font-semibold" }, " আমাদের সাথে যুক্ত হও ", -1))
const _hoisted_8 = { class: "flex flex-col px-3 xs:px-4 sm:mx-auto" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title font-bold" }, " যোগাযোগ ", -1))
const _hoisted_10 = { class: "mt-2 flex" }
const _hoisted_11 = { class: "icon mr-1 mt-0.5" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "mt-1 flex" }
const _hoisted_14 = { class: "icon mr-1 mt-0.5" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "mt-1 flex" }
const _hoisted_17 = { class: "icon mr-1 mt-0.5" }
const _hoisted_18 = { class: "ml-auto flex flex-col px-3 xs:px-4" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title font-bold" }, " কোম্পানি ", -1))
const _hoisted_20 = { class: "mb-3 mt-5 text-center xs:mt-8 sm:mt-12" }
const _hoisted_21 = { class: "sm:hidden" }
const _hoisted_22 = ["src"]

import {
  MapPinIcon,
} from '@heroicons/vue/24/outline';
import {
  PhEnvelopeSimple,
  PhPhoneCall,
} from '@phosphor-icons/vue';
import DevelopedByWithLogo from '@/components/App/DevelopedByWithLogo.vue';
import SocialLink from '@/components/App/Footer/SocialLink.vue';
import {
  CONSTANTS,
} from '@/helpers';
import {
  useStore,
} from '@/store';
import type {
  INav,
} from '@/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicFooter',
  setup(__props) {


const currentYear = new Date().getFullYear();

const {
  alternateName: appName,
  tradeLicenseNo,
  email,
  contactAddress,
  contactNo,
  imageSettings,
} = useStore.backend.clientCompany;

const availableNavs: INav[] = [
  {
    ...CONSTANTS.ROUTE.faq,
  },
  {
    ...CONSTANTS.ROUTE.aboutUs,
  },
  {
    ...CONSTANTS.ROUTE.termsOfService,
  },
  {
    ...CONSTANTS.ROUTE.privacyPolicy,
  },
  {
    ...CONSTANTS.ROUTE.refundPolicy,
  },
];


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _unref(imageSettings).logoHorizontal,
            alt: "logo",
            class: "h-10 w-fit"
          }, null, 8, _hoisted_5),
          _createElementVNode("p", _hoisted_6, " ট্রেড লাইসেন্স: " + _toDisplayString(_unref(tradeLicenseNo)), 1),
          _hoisted_7,
          _createVNode(SocialLink)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, [
              _createVNode(_unref(PhPhoneCall), { class: "icon" })
            ]),
            _createElementVNode("span", null, [
              _createElementVNode("a", {
                href: `tel:${_unref(contactNo)}`
              }, _toDisplayString(_unref(contactNo)), 9, _hoisted_12)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, [
              _createVNode(_unref(PhEnvelopeSimple), { class: "icon" })
            ]),
            _createElementVNode("span", null, [
              _createElementVNode("a", {
                href: 'mailto:' + _unref(email)
              }, _toDisplayString(_unref(email)), 9, _hoisted_15)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("span", _hoisted_17, [
              _createVNode(_unref(MapPinIcon), { class: "icon" })
            ]),
            _createElementVNode("span", null, _toDisplayString(_unref(contactAddress)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(availableNavs, (nav) => {
            return _createVNode(_component_RouterLink, {
              key: nav.alternateTitle,
              class: "mt-1 hover:text-yellow-2",
              to: nav.path,
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(nav.alternateTitle), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          }), 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("p", null, " ট্রেড লাইসেন্স: " + _toDisplayString(_unref(tradeLicenseNo)), 1),
          _createVNode(SocialLink, { class: "my-4" })
        ]),
        _createElementVNode("img", {
          src: require('@/assets/site-assets/pay-with-1.png'),
          alt: "pay-with-1",
          class: "mx-auto mb-6 px-4"
        }, null, 8, _hoisted_22),
        _createElementVNode("p", null, " Copyright © " + _toDisplayString(_unref(currentYear)) + " " + _toDisplayString(_unref(appName)) + ", All Rights Reserved. ", 1),
        _createVNode(DevelopedByWithLogo, { class: "mt-2" })
      ])
    ])
  ]))
}
}

})